import { render, staticRenderFns } from "./DragGridTable.vue?vue&type=template&id=23b030fe&scoped=true"
import script from "./DragGridTable.vue?vue&type=script&lang=js"
export * from "./DragGridTable.vue?vue&type=script&lang=js"
import style0 from "./DragGridTable.vue?vue&type=style&index=0&id=23b030fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b030fe",
  null
  
)

export default component.exports